import * as React from 'react';
import { StyleSheet } from 'react-native';
import Colors from '../../constants/Colors';
import { View } from '../Themed';
import { Orientation } from '../../types';

type Props = {
 orientation?: Orientation
};

export default function Line(props: Props) {
  const {orientation = Orientation.Horizontal } = props;
  
  return (orientation == Orientation.Vertical ?
    <View style={styles.vertical}></View>
    : <View style={styles.horizontal}></View>
    )

  
}

const styles = StyleSheet.create({
  horizontal: {
    borderTopColor: Colors.tinted_grey_300,
    borderTopWidth: 1,
  },
  vertical: {
    borderLeftColor: Colors.tinted_grey_300,
    borderLeftWidth: 1,
  },
});
